import { useTranslation } from 'react-i18next'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'
import { ensureExists } from '~/utils'

import { pathKey } from '../utils'

export const useBrandGroupId = () => {
  const { t } = useTranslation()
  const { brandGroupId } = usePathParams(pathKey)

  return ensureExists(brandGroupId, t('assertion_failed'))
}
